import type { RouterLinkRender } from "@repo/ui/Link/routerLink";
import { Link as RouterLink } from "react-router";

/**
 * Renders React Router's `Link` for the React Aria elements that carry an
 * `href`. Mounted once through `RouterLinkProvider`; see
 * [.agents/wiki/admin-routing.md](../../../../.agents/wiki/admin-routing.md).
 */
export const renderRouterAnchor: RouterLinkRender = ({ href, ...domProps }) => (
  <RouterLink {...domProps} to={href} />
);
